import React, { useState, useEffect } from "react";
import axios from "../../services/api";
import UserForm from "./UserForm";
import "../../styles/UserForm.css";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 6;

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/users");
      setUsers(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  // ✅ Filter Users Based on Search
  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.phone.toLowerCase().includes(searchTerm.toLowerCase()) || // ✅ Search by phone
    user.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ✅ Pagination Logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div className="user-container">
      {/* Header Section */}
      <div className="user-header">
        <h2>Users</h2>
        <button
          onClick={() => {
            setShowForm(true);
            setSelectedUser(null);
          }}
          className="add-user-btn"
        >
          + Add User
        </button>
      </div>

      {/* Search Box */}
      <input
        type="text"
        placeholder="Search by name, email, phone, or role..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-box"
      />

      {/* User Form Popup */}
      {showForm && (
        <UserForm
          userId={selectedUser}
          onClose={() => setShowForm(false)}
          refreshUsers={fetchUsers}
        />
      )}

      {/* Loading State */}
      {loading ? (
        <p className="loading-text">Loading users...</p>
      ) : (
        <>
          {/* User Cards */}
          <div className="user-list">
  {currentUsers.length > 0 ? (
    currentUsers.map((user) => (
      <div key={user.id} className="user-card">
        <div className="user-info">
          <h3>{user.name}</h3>
          <p>Email: {user.email}</p>
          <p>Phone: {user.phone || "N/A"}</p> {/* ✅ Show phone number */}
          <p>Role: <span className="role-badge">{user.role}</span></p>
          <p>
            Status:{" "}
            {user.activated ? (
              <span className="status-badge active">Activated</span>
            ) : (
              <span className="status-badge inactive">Deactivated</span>
            )}
          </p>
        </div>
        <div className="user-actions">
          <button
            className="edit-btn"
            onClick={() => {
              setShowForm(true);
              setSelectedUser(user.id);
            }}
          >
            Edit
          </button>
          <button className="delete-btn">Delete</button>
        </div>
      </div>
    ))
  ) : (
    <p className="no-results">No users found.</p>
  )}
</div>


          {/* Pagination Controls */}
          {filteredUsers.length > usersPerPage && (
            <div className="pagination">
              <button onClick={prevPage} disabled={currentPage === 1} className="pagination-btn">
                ◀ Prev
              </button>
              <span className="page-number">
                Page {currentPage} of {totalPages}
              </span>
              <button onClick={nextPage} disabled={currentPage === totalPages} className="pagination-btn">
                Next ▶
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserList;
